// @flow
import { NOTIFICATIONS_REDUCER_KEY } from './notificationsReducer';

const getStore = (state: Object) => state[NOTIFICATIONS_REDUCER_KEY];
export const getNotifications = (state: Object) => getStore(state).notifications;
export const getNotificationById = (state: Object, id: string) => getNotifications(state).get(id);
